export const MAX_ALTERNATIVE_EXERCISES = 4;

export enum AlternativeErrorType {
	ThisAlreadyExists = "ThisAlreadyExists",
	OneAlreadyExists = "OneAlreadyExists",
	MaxExercisesReached = "MaxExercisesReached",
}
